import React from 'react'
import { token } from '@planningcenter/tapestry'
import { Box } from '@planningcenter/tapestry-react'

const Pane = ({ theme, css, ...props }) => {
  const styles = {
    border: `1px solid ${token('--t-border-color')}`,
    borderRadius: '4px',
    marginBottom: '16px',
    padding: '15px',
    ':last-child': { marginBottom: '0' },
    background: theme === 'dark' ? '#2b303b' : token('--t-surface-color-card'),
    ...css,
  }
  return <Box css={styles} {...props} />
}

export default Pane
